import { IAppEntity } from "../../entities";
import React from "react";
import { CreateVehicleDto } from "../../../dtos/catalogs/vehicle/CreateVehicleDto";
import { VehicleService } from "../../../services/catalogs/VehicleService";
import { ReferenceTypes } from "../../../enums/ReferenceTypes";
import { NFLookupVehicle } from "../../../components/Shared/NewForms/NFLookupVehicle";
import { VehicleDetail } from "../../../components/Pages/Catalogs/Vehicle/VehicleDetail";
import VehicleList from "../../../components/Pages/Catalogs/Vehicle/VehicleList";
import { VendorSettlementAnalyticsDetail } from "../../../components/Pages/Catalogs/VendorSettlementAnalytics/VendorSettlementAnalyticsDetail";
import VendorSettlementAnalyticsList from "../../../components/Pages/Catalogs/VendorSettlementAnalytics/VendorSettlementAnalyticsList";
import { NFLookupVendorSettlementAnalytics } from "../../../components/Shared/NewForms/NFLookupVendorSettlementAnalytics";
import { CreateVendorSettlementAnalyticsDto } from "../../../dtos/catalogs/VendorSettlementAnalytics/CreateVendorSettlementAnalyticsDto";

export const VendorSettlementAnalytics: IAppEntity = {
  entityType: "catalog",
  title: "VendorSettlementAnalytics",
  pluralTitle: "VendorSettlementAnalytics",
  apiUrl: "VendorSettlementAnalytics",
  apiEnum: ReferenceTypes.CatalogVendorSettlementAnalytic,
  getDetailViewComponent(model: any, modelUpdatedEvent: (model: any) => void): any {
    return React.createElement(VendorSettlementAnalyticsDetail, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent
    });
  },
  getListView: (model: any, modelUpdatedEvent: (model: any) => void) =>
    React.createElement(VendorSettlementAnalyticsList, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent
    }),
  getLookupComponent(model: any): any {
    return React.createElement(NFLookupVendorSettlementAnalytics, {
      fieldName: model.fieldName,
      title: model.title,
      setSelectedCatalog: model.setSelectedCatalog
    });
  },
  getDataService() {
    return new VehicleService(this.apiUrl);
  },
  getEmptyModel(): CreateVendorSettlementAnalyticsDto {
    return {
      name: "",
    };
  }
};
